import { type RefObject, useEffect } from 'react';

const DEPLOY = typeof window !== 'undefined';

export function useCallbackWhenIntersected(ref: RefObject<HTMLElement | null>, callback?: () => any) {
  const observer = DEPLOY
    ? new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          if (callback) callback();
          observer?.disconnect();
        }
      })
    : null;

  useEffect(() => {
    if (DEPLOY && ref.current && observer) {
      observer.observe(ref.current);
    }
  }, [ref]); /* observer not included intentionally */
}
